export const ContrastEnhanceMode = {
  NONE: 0,
  LIC: 1,
  COLOR: 2,
  BOTH: 3,
};

export const NoiseType = {
  UNIFORM: 0,
  GAUSSIAN: 1,
};

export const ColorMode = {
  BLEND: 0,
  MULTIPLY: 1,
};

export default {
  ColorMode,
  ContrastEnhanceMode,
  NoiseType,
};
